import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const BookingPlatforms = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const platforms = [
    {
      name: 'Booking.com',
      logo: '/images/booking-com-logo.svg',
      caption: 'Book via Booking.com',
      link: 'https://www.booking.com/hotel/my/mikhael-homestay-near-uitm-segamat.html'
    },
    {
      name: 'Airbnb',
      logo: '/images/airbnb-logo.svg',
      caption: 'Book via Airbnb',
      link: 'https://airbnb.com/h/mikhaelhomestay'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <div id="booking-platforms" className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-12 text-center">
        <motion.h2 
          className="text-3xl md:text-4xl font-semibold text-gray-900 mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Choose Your Booking Platform
        </motion.h2>
      </div>
      
      <motion.div 
        className={`flex ${isMobile ? 'flex-col' : 'flex-row'} justify-center items-center gap-8 md:gap-16 mb-12`}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {platforms.map((platform) => (
          <motion.div 
            key={platform.name}
            className="flex flex-col items-center"
            variants={itemVariants}
          >
            <a 
              href={platform.link} 
              target="_blank" 
              rel="noopener noreferrer"
              className="group transition-all duration-300 ease-in-out"
              aria-label={`Book Mikhael Homestay via ${platform.name}`}
            >
              <div className="relative w-48 h-48 sm:w-64 sm:h-64 flex items-center justify-center p-8 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 ease-in-out transform group-hover:scale-105 border border-gray-100">
                <div className="relative w-full h-full">
                  <img
                    src={platform.logo}
                    alt={`${platform.name} logo`}
                    className="object-contain p-4 w-full h-full"
                  />
                </div>
              </div>
              <p className="mt-6 text-center text-lg font-medium text-gray-700 group-hover:text-blue-600 transition-colors duration-300">
                {platform.caption}
              </p>
            </a>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default BookingPlatforms;
